<template>
  <div id="directory-ui">
    <directory :viewType="viewType" :catId="catId"></directory>
  </div>
</template>
<script>
import Directory from './components/Directory.vue';

export default {
  name: 'app',
  data() {
    return {
      viewType: null,
      catId: null,
    };
  },
  beforeMount() {
    this.viewType = this.$parent.viewType;
    this.catId = this.$parent.catId;
  },
  components: {
    Directory,
  },
};
</script>

<style lang="scss"></style>
